import {Tabs as AntdTabs} from "../../../__snowpack__/pkg/antd.js";
import React, {useContext, useMemo, useRef} from "../../../__snowpack__/pkg/react.js";
import {TabsContext} from "./Tabs.js";
export const TabPaneContext = React.createContext(null);
export default function TabPane(props) {
  const context = useContext(TabsContext);
  const ref = useRef({refreshDep: 0});
  const values = useMemo(() => {
    if (context === null) {
      return null;
    }
    if (context.activeKey === props.tabKey) {
      ref.current.refreshDep += 1;
    }
    return {
      tabKey: props.tabKey,
      isActivated: context.activeKey === props.tabKey,
      refreshDep: ref.current.refreshDep
    };
  }, [context?.activeKey, props.tabKey]);
  return /* @__PURE__ */ React.createElement(TabPaneContext.Provider, {
    value: values
  }, /* @__PURE__ */ React.createElement(AntdTabs.TabPane, {
    key: props.tabKey,
    ...props
  }));
}
